import { connect } from 'react-redux';

import { getOfficesShortList } from '../../Offices/officesActions';
import { getOrganizationMembersList } from '../../Projects/projectsActions';
import {
  addTaskLocation,
  clearTaskState,
  editTask,
  getTaskDetails,
  getTaskLocation,
  getTaskType,
  getMasterTask,
  getLocationTypeList,
} from '../tasksActions';
// Component
import EditTask from './EditTask';

// Store props to map with current state
const mapStateToProps = state => ({
  selectedOrganization: state.organization.selectedOrganization,
  orgMembersList: state.project.orgMembersList,
  isLoading: state.task.isLoading,
  officesShortList: state.office.officesShortList,
  memberShortListIsLoading: state.project.memberShortListIsLoading,
  addTaskLocationLoading: state.task.addTaskLocationLoading,
  locationsList: state.task.locationsList,
  createdTaskLocationInfo: state.task.createdTaskLocationInfo,
  callback: state.task.callback,
  taskDetails: state.task.taskDetails,
  taskTypeIsLoading: state.task.taskTypeIsLoading,
  taskTypeList: state.task.taskTypeList,
  isMasterTaskLoading: state.task.isMasterTaskLoading,
  MasterTasks: state.task.MasterTasks,
  locationTypeList: state.task.locationTypeList,
  getLocationTypeListLoading: state.task.getLocationTypeListLoading,
});

// Actions prop to dispatch
const mapDispatchToProps = dispatch => ({
  getOrganizationMembersList: params =>
    dispatch(getOrganizationMembersList(params)),
  getTaskDetails: params => dispatch(getTaskDetails(params)),
  editTask: params => dispatch(editTask(params)),
  getTaskLocation: params => dispatch(getTaskLocation(params)),
  addTaskLocation: params => dispatch(addTaskLocation(params)),
  getOfficesShortList: params => dispatch(getOfficesShortList(params)),
  getTaskType: params => dispatch(getTaskType(params)),
  getMasterTask: (params) => dispatch(getMasterTask(params)),
  clearTaskState: () => dispatch(clearTaskState()),
  getLocationTypeList: (params) => dispatch(getLocationTypeList(params)),
});

// connect states and dispatchers with components
export default connect(mapStateToProps, mapDispatchToProps)(EditTask);
